import { render } from "./TierList.vue?vue&type=template&id=790f21b4"
import script from "./TierList.vue?vue&type=script&lang=js"
export * from "./TierList.vue?vue&type=script&lang=js"

import "./TierList.vue?vue&type=style&index=0&id=790f21b4&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__